'use strict';

$.widget('fotobook.currentAlbumMulticolumnDropdown', $.fotobook.multicolumnDropdown, {
    options: {
        selectedValue: -1,
        fotoTpl: '<img class="foto" src="{href}" alt="">',
    },

    getFotoUrl(foto) {
        return Fotobook.createStorageUrl(foto.preview_path + '?v=' + foto.version);
    },

    _renderOptionContent(foto) {
        return this.options.fotoTpl.supplant({
            href: this.getFotoUrl(foto).escapeAttr(),
        });
    },

    _getOptionsData() {
        const widget = this;
        let images = Fotobook.fotoManager.imagesTab._images;
        // exclude broken images
        images = images.filter((image) => image.originalExists === true);

        return images.map((foto) => {
            return {
                value: foto.id,
                text: widget.getFotoUrl(foto).escapeAttr(),
                selected: foto.id == widget.options.selectedValue,
                item: foto,
            };
        });
    },

    _create() {
        const widget = this;
        this._super();
        this.disable();
        Fotobook.fotoManager.imagesTab.checkLoaded().then(() => {
            widget._createOptions();
            widget.refresh();
            widget.enable();
        });
    },
});
